import React from 'react'

export default function Hero() {
  return (
<section className="profile-hero py-5 d-flex align-items-center justify-content-center">
  <div className="hero-slogan">
    <p className="lead mb-0">Talking therapies, a space to discuss wellbeing</p>
  </div>
</section>
  )
}
